import Phaser from "phaser";
import LoadingScene from "@/games/ForagingTutorial/scenes/LoadingScene";
import RoundStartScene from "@/games/ForagingTutorial/scenes/RoundStartScene";
import QuestionScene from "@/games/ForagingTutorial/scenes/QuestionScene";
import PlayScene from "@/games/ForagingTutorial/scenes/PlayScene";
import AnsCorrectPlayScene from "@/games/ForagingTutorial/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/games/ForagingTutorial/scenes/AnsWrongPlayScene";
import BossScene from "@/games/ForagingTutorial/scenes/BossScene";
import LandingScene from "@/games/ForagingTutorial/scenes/LandingScene";
import Settings from "@/games/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
